var exports = {
  "rg": "zone-TWRKS",
  "jC": "padded-TWRKS",
  "hm": "flexdiv-TWRKS",
  "vu": "active-TWRKS",
  "Ju": "accept-TWRKS",
  "ku": "reject-TWRKS",
};

module.exports = exports;
